import { render, staticRenderFns } from "./RoteirizacaoProgressoDestinos.vue?vue&type=template&id=4d678a5e&scoped=true&"
import script from "./RoteirizacaoProgressoDestinos.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoProgressoDestinos.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoProgressoDestinos.vue?vue&type=style&index=0&id=4d678a5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d678a5e",
  null
  
)

export default component.exports